"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertNotificationSidebarContent = void 0;
const react_1 = __importDefault(require("react"));
const styled_1 = require("../styled");
const card_1 = require("../card/card");
const wl_ui_kit_1 = require("@invent/wl-ui-kit");
const ramda_1 = require("ramda");
const Section = ({ items, type }) => {
    if (type === 'alerts') {
        return (react_1.default.createElement(react_1.default.Fragment, null, items.map((item) => (react_1.default.createElement(card_1.Card, Object.assign({ key: item.id }, item))))));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, items.map((item) => (react_1.default.createElement(card_1.Card, Object.assign({ key: item.id }, item))))));
};
const AlertNotificationSidebarContent = ({ sections, type, isTabDataLoading, title, totalItems }) => {
    if (isTabDataLoading) {
        return (react_1.default.createElement(styled_1.LoadingWrapper, null,
            react_1.default.createElement(wl_ui_kit_1.LoadingOverlay, null)));
    }
    if ((0, ramda_1.isEmpty)(sections) || !Boolean(totalItems)) {
        return react_1.default.createElement(wl_ui_kit_1.Body2, { style: { padding: '24px 28px' } }, `There are no ${title} at the moment.`);
    }
    return (react_1.default.createElement(styled_1.ContentWrapper, null, sections.map(({ id, items, title }) => (react_1.default.createElement(react_1.default.Fragment, null,
        title && react_1.default.createElement(styled_1.SectionTitle, { key: `${id}-title` }, title),
        react_1.default.createElement(Section, { key: id, items: items, type: type }))))));
};
exports.AlertNotificationSidebarContent = AlertNotificationSidebarContent;
